var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.425,
    height: 49.311,
    viewBox: "0 0 60.425 49.311",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "crown",
    d: "M57.319,7.831A5.02,5.02,0,0,0,51.83,8.924l-6.511,6.511L33.773,3.889a5.035,5.035,0,0,0-7.12,0L15.106,15.435,8.6,8.924A5.035,5.035,0,0,0,0,12.484V39.137A12.6,12.6,0,0,0,12.589,51.725H47.837A12.6,12.6,0,0,0,60.425,39.137V12.484A5.035,5.035,0,0,0,57.319,7.831ZM55.39,39.137a7.553,7.553,0,0,1-7.553,7.553H12.589a7.553,7.553,0,0,1-7.553-7.553V12.484l8.291,8.291a2.518,2.518,0,0,0,3.56,0L30.213,7.449,43.539,20.775a2.518,2.518,0,0,0,3.56,0l8.291-8.291Z",
    transform: "translate(0 -2.414)",
    fill: "#daa520"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.5044ef72c2ce04f6cc268a5fc9c794c1.svg";
export { ForwardRef as ReactComponent };